import React from 'react';

const TimeWarningModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-sm">
        <h2 className="text-xl font-bold mb-4 text-black">Time Warning</h2>
        <p className="text-black">You have 3 minutes remaining in this conversation. Please start wrapping up.</p>
        <button
          onClick={onClose}
          className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Okay
        </button>
      </div>
    </div>
  );
};

export default TimeWarningModal;